/* cl-cart.js — gaveta do carrinho (replica do cart-drawer do Clutch dele), Ajax API do Shopify, vanilla.
   API: window.clCart.open(), .close(), .refresh(), .add(items[, url]) -> Promise(cart).
   - 'cl:cart:open' (cl-ui.js: icone do header e ATC) -> recarrega /cart.js e abre;
   - itens desenhados pelo <template data-cl-line-tpl>; quantidade (change/blur) e Remove -> /cart/change.js;
   - "Your order is reserved for 03:00 min": contagem por sessao; barra de frete gratis com a meta dele;
   - protecao de envio (package-insurance) entra junto no 1o ATC como no dele; se o cliente remover, nao volta. */
(function () {
  'use strict';
  if (window.clCart) return;
  var root = document.querySelector('[data-cl-cart-drawer]');
  if (!root) return;
  var tpl = root.querySelector('template[data-cl-line-tpl]');
  var lines = root.querySelector('[data-cl-lines]');
  var FS = parseInt(root.getAttribute('data-fs-threshold') || '0', 10);
  var INS = parseInt(root.getAttribute('data-insurance') || '0', 10);
  var INS_KEY = 'cl-ins-removed';

  function fmt(cents, withCur) {
    var tplm = (withCur ? window.clMoneyFormatCur : window.clMoneyFormat) || 'R$ {{amount_with_comma_separator}}';
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    var comma = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    var dot = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1];
    return tplm.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return v[0];
      if (k === 'amount_no_decimals_with_comma_separator') return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return /comma/.test(k) ? comma : dot;
    });
  }
  function json(url, body) {
    var o = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { o.method = 'POST'; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'cart'); e.data = d; throw e; } return d; });
    });
  }
  function img(it) {
    var u = it.featured_image && it.featured_image.url || it.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function bubble(n) {
    root.querySelectorAll('[data-cl-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !n); el.hidden = false; });
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
  }

  function line(it) {
    var n = tpl.content.firstElementChild.cloneNode(true);
    n.setAttribute('data-key', it.key);
    var f = function (k) { return n.querySelectorAll('[data-f="' + k + '"]'); };
    f('img').forEach(function (e) { e.src = img(it); e.alt = it.product_title || ''; });
    f('url').forEach(function (e) { e.href = it.url; });
    f('title').forEach(function (e) { e.textContent = it.product_title; });
    f('price').forEach(function (e) { e.textContent = fmt(it.final_line_price); });
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
      .map(function (o) { return o.name + ': ' + o.value; }).join(' / ');
    f('opts').forEach(function (e) { e.textContent = opts; e.hidden = !opts; });
    f('qty').forEach(function (e) {
      e.value = it.quantity;
      var go = function () {
        var q = parseInt(e.value, 10); if (isNaN(q) || q < 0) q = 1;
        if (q !== it.quantity) change(it.key, q, n);
      };
      e.addEventListener('change', go);
      e.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); e.blur(); } });
    });
    f('rm').forEach(function (e) {
      e.href = '/cart/change?id=' + encodeURIComponent(it.key) + '&quantity=0';
      e.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (it.variant_id === INS) { try { sessionStorage.setItem(INS_KEY, '1'); } catch (x) {} }
        change(it.key, 0, n);
      });
    });
    return n;
  }

  function render(cart) {
    var has = cart.item_count > 0;
    bubble(cart.item_count);
    root.querySelector('[data-cl-cd-filled]').hidden = !has;
    root.querySelector('[data-cl-cd-empty]').hidden = has;
    root.querySelector('[data-cl-cd-footer]').hidden = !has;
    lines.innerHTML = '';
    cart.items.forEach(function (it) { lines.appendChild(line(it)); });
    var tot = root.querySelector('[data-cl-total]');
    if (tot) tot.textContent = fmt(cart.total_price, true);
    var msg = root.querySelector('[data-cl-fs-msg]'), bar = root.querySelector('[data-cl-fs-bar]');
    if (FS && msg && bar) {
      var left = FS - cart.total_price;
      msg.textContent = left <= 0 ? 'Congrats! You have free shipping' : 'Spend ' + fmt(left) + ' more and get free shipping!';
      bar.style.setProperty('--progress', Math.min(1, cart.total_price / FS));
      bar.setAttribute('aria-valuenow', cart.total_price);
    }
    return cart;
  }
  function refresh() { return json('/cart.js').then(render); }
  function change(key, q, node) {
    if (node) node.classList.add('is-busy');
    return json('/cart/change.js', { id: key, quantity: q }).then(render).catch(function () { return refresh(); });
  }

  function insurance(cart) {
    if (!INS || !cart.item_count) return cart;
    var removed = false; try { removed = sessionStorage.getItem(INS_KEY) === '1'; } catch (x) {}
    if (removed || cart.items.some(function (it) { return it.variant_id === INS; })) return cart;
    return json('/cart/add.js', { items: [{ id: INS, quantity: 1 }] }).then(function () { return json('/cart.js'); }).catch(function () { return cart; });
  }

  var tick = null;
  function timer() {
    var el = root.querySelector('[data-cl-timer]');
    if (!el || tick) return;
    var end = 0; try { end = parseInt(sessionStorage.getItem('cl-reserve') || '0', 10); } catch (x) {}
    if (!end || end < Date.now()) { end = Date.now() + 180000; try { sessionStorage.setItem('cl-reserve', String(end)); } catch (x) {} }
    var paint = function () {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      el.textContent = (s / 60 < 10 ? '0' : '') + Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
      if (!s) { clearInterval(tick); tick = null; }
    };
    paint(); tick = setInterval(paint, 1000);
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('cl-cart-open');
    timer();
    var d = root.querySelector('[role="dialog"]'); if (d) try { d.focus({ preventScroll: true }); } catch (x) {}
  }
  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('cl-cart-open');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (x) {}
  }
  function add(items, url) {
    return json(url || '/cart/add.js', { items: items }).then(function () { return json('/cart.js'); })
      .then(insurance).then(render).then(function (c) { open(); return c; })
      .catch(function (e) { refresh().then(open); throw e; });
  }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-cl-cd-close]')) { e.preventDefault(); close(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  document.addEventListener('cl:cart:open', function () {
    json('/cart.js').then(insurance).then(render).then(open, function () { open(); });
  });
  window.clCart = { open: open, close: close, refresh: refresh, add: add };
  refresh().catch(function () {});
})();
